<template>
  <v-dialog v-model="paychecks_dialog" max-width="700" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="green lighten-1 d-flex justify-center"
        dark
        small
        class="mb-2"
        v-bind="attrs"
        v-on="on"
      >
        Inserir Vários
        <v-icon class="pl-2">mdi-cloud-upload</v-icon>
      </v-btn>
    </template>
    <v-card class="pb-2">
      <v-app-bar color="red lighten-1" dark dense>
        <v-toolbar-title>Inserir diversos contracheques</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon>mdi-cloud-upload</v-icon>
      </v-app-bar>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="mt-4">
            <v-alert text outlined color="orange" icon="mdi-alert-box" class="py-2 px-1 my-0">
              Selecione os arquivos que deseja inserir.
            </v-alert>
          </v-col>
          <v-col v-if="mensages.refresh" cols="12" sm="12" md="12" lg="12" class="my-0 mb-2 py-0">
            <v-alert text outlined color="blue" icon="mdi-refresh" class="py-2 px-1 my-0">
              Alguns contracheques ja existem no banco de dados, clique no item com o icone azul
              para sobrescrever.
            </v-alert>
          </v-col>
          <v-col v-if="mensages.error" cols="12" sm="12" md="12" lg="12" class="my-0 mb-2 py-0">
            <v-alert text outlined color="red" icon="mdi-close" class="py-2 px-1 my-0">
              Alguns contracheques nao foram inseridos, clique no item com o icone vermelho para
              tentar novamente.
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0">
              <v-toolbar elevation="0">
                <v-toolbar-title>Lista de contracheques</v-toolbar-title>
              </v-toolbar>
              <v-divider></v-divider>
              <v-list two-line max-height="300" class="overflow-y-auto">
                <v-list-item-group active-class="red--text">
                    <v-list-item
                      v-for="(doc, index) in form.docs" :key="doc.name"
                      dense
                      @click="form.status[index] == 'refresh' ? updatePaycheck(index) : null"
                    >
                      <v-list-item-avatar>
                        <v-icon v-if="form.status[index] == 'created'" large>mdi-pdf-box</v-icon>
                        <v-progress-circular
                          v-if="form.status[index] == 'loading'"
                          indeterminate
                          color="red"
                        ></v-progress-circular>
                        <v-icon v-if="form.status[index] == 'success'" color="green" large
                          >mdi-check</v-icon
                        >
                        <v-icon v-if="form.status[index] == 'error'" color="red" large
                          >mdi-close</v-icon
                        >
                        <v-icon v-if="form.status[index] == 'refresh'" color="blue" large
                          >mdi-refresh</v-icon
                        >
                      </v-list-item-avatar>
                      <v-list-item-content>
                        {{ form.employees[index] ? form.employees[index].full_name : doc.name }}
                        <br />
                        {{ form.date[index] ? form.date[index] : '' }}
                      </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-select
              v-model="$v.form.month.$model"
              :items="months_of_the_year"
              item-value="id"
              item-text="name"
              label="Mês de Referência"
              outlined
              dense
              class="m-0 p-0"
              hide-details="auto"
              :error-messages="errors.data.month"
              @change="errorMensage('month')"
              @blur="errorMensage('month')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-select
              v-model="$v.form.year.$model"
              :items="listYears"
              label="Ano"
              outlined
              dense
              class="mx-2"
              single-line
              :error-messages="errors.data.year"
              @change="errorMensage('year')"
              @blur="errorMensage('year')"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-file-input
              v-model="form.docs"
              show-size
              prepend-icon="mdi-file-pdf"
              multiple
              accept="application/pdf"
              label="Contracheques"
              @click:clear="clearData"
            >
            </v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between px-6">
        <v-btn color="red lighten-1" class="px-10 white--text" @click="closeDialog"> Fechar </v-btn>
        <v-btn class="px-10 white--text" color="green" @click="submitPaychecks"> Enviar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'FormMultiPaychecks',
  data: function () {
    return {
      mensages: {
        refresh: false,
        error: false,
      },
      errors: {
        mensages: { required: 'O campo e obrigatorio' },
        data: { month: '', year: '' },
      },
      currentYear: new Date().getFullYear(),
      paychecks_dialog: false,
      form: {
        month: '',
        year: '',
        docs: [],
        status: [],
        employees: [],
        date: [],
      },
    }
  },
  computed: {
    ...mapState('utils', ['months_of_the_year']),
    ...mapState('employees', ['employees', 'paychecks']),
    status() {
      return this.form.status
    },
    docs() {
      return this.form.docs
    },
    isLoading() {
      return (index) => this.form.loading[index]
    },
    listYears() {
      let initialYear = this.currentYear - 2
      const listYears = []

      for (let i = 0; i <= 1; i++) {
        let year = initialYear + i
        listYears.push(year.toString())
      }
      listYears.push(this.currentYear.toString())

      return listYears
    },
  },
  validations: {
    form: {
      month: {
        required,
      },
      year: {
        required,
      },
    },
  },
  watch: {
    status() {
      if (this.form.status.filter((status) => status == 'refresh').length > 0) {
        this.mensages.refresh = true
      } else {
        this.mensages.refresh = false
      }

      if (this.form.status.filter((status) => status == 'error').length > 0) {
        this.mensages.error = true
      } else {
        this.mensages.error = false
      }
    },
    paychecks_dialog() {
      if (!this.paychecks_dialog) {
        this.clearData()
      }
    },
    docs() {
      this.form.docs.map((doc) => {
        this.form.status.push('created')
      })
    },
  },
  methods: {
    ...mapActions('employees', ['ActionStorePaycheckEmployee', `ActionUpdatePaycheckEmployee`]),
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.mensages.required)

      this.errors.data[key] = errors
    },
    async submitPaychecks() {
      this.$v.$touch()
      console.log(this.form)
      this.form.docs.map(async (doc, index) => {
        if (this.form.status[index]) {
          if (this.form.status[index] == 'success') return
          else {
            this.form.status[index] = 'loading'
          }
        }
        let paycheck = new FormData()
        let data = doc.name.split(' ')

        let lastIndex = data.length - 1
        let dataSplit = data[lastIndex].split('.')
        let employeeRegistration = dataSplit[0]

        console.log()
        let employee = this.employees.find(
          (employee) => parseInt(employee.employee_registration) == parseInt(employeeRegistration)
        )

        if (employee) {
          let paycheck_exists = this.paychecks
            .filter((paycheck) => paycheck.user_id == employee.id)
            .filter((paycheck) => paycheck.year == this.form.year)
            .filter((paycheck) => paycheck.month_id == this.form.month)
          if (paycheck_exists.length > 0) {
            this.$set(this.form.status, index, 'refresh')
            return
          }
          this.$set(this.form.employees, index, employee)
          this.$set(this.form.date, index, `${data[1]}/${data[2]}`)
          paycheck.append('files', doc, doc.name)
          paycheck.append('employee_id', employee.id)
          paycheck.append('months_of_the_year_id', this.form.month)
          paycheck.append('year', this.form.year)
          try {
            await this.ActionStorePaycheckEmployee(paycheck)
            this.$set(this.form.status, index, 'success')
          } catch (error) {
            this.$set(this.form.status, index, 'error')
          }
        } else {
          this.$set(this.form.status, index, 'error')
        }
      })
    },
    async sendPaycheck(index) {
      console.log(index)
      setTimeout(() => {
        console.log(`enviado`)
        this.$set(this.form.status, index, 'error')
      }, 500)
    },
    getEmployeeIdByRegistration(registration) {
      return this.employees.filter((employee) => employee.employee_registration == registration)[0]
    },
    closeDialog() {
      if (this.form.status.length > 0) {
        if (this.form.status.filter((status) => status == 'loading').length > 0) {
          this.$swal({
            icon: 'warning',
            title: 'Atencao',
            text: 'Alguns contracheques estao sendo enviados aguarde',
            confirmButtonText: `Ok`,
          })
          return
        } else if (this.form.status.filter((status) => status == 'error').length > 0) {
          this.$swal({
            icon: 'warning',
            title: 'Atencao',
            text: 'Alguns contracheques nao foram inseridos, deseja fechar?',
            showCancelButton: true,
            confirmButtonText: `Fechar`,
            cancelButtonText: `Cancelar`,
          }).then((result) => {
            if (result.isConfirmed) {
              this.form = {
                month: '',
                year: '',
                docs: [],
                status: [],
                employees: [],
                date: [],
              }
              this.paychecks_dialog = false
            }
          })
        } else {
          this.form = {
            month: '',
            year: '',
            docs: [],
            status: [],
            employees: [],
            date: [],
          }
          this.paychecks_dialog = false
        }
      } else {
        this.form = {
          month: '',
          year: '',
          docs: [],
          status: [],
          employees: [],
          date: [],
        }
        this.paychecks_dialog = false
      }
    },
    async updatePaycheck(index) {
      let doc = this.form.docs[index]
      let paycheck = new FormData()
      let data = doc.name.split('-')
      let employee = this.employees.find((employee) => employee.employee_registration == data[4])
      if (employee) {
        let paycheck_exists = this.paychecks
          .filter((paycheck) => paycheck.user_id == employee.id)
          .filter((paycheck) => paycheck.year == data[2])
          .filter((paycheck) => paycheck.month_id == data[1])[0]
        this.$set(this.form.status, index, 'loading')
        this.$set(this.form.employees, index, employee)
        this.$set(this.form.date, index, `${data[1]}/${data[2]}`)

        paycheck.append('files', doc, doc.name)
        paycheck.append('employee_id', employee.id)
        paycheck.append('months_of_the_year_id', data[1])
        paycheck.append('year', data[2])
        try {
          await this.ActionUpdatePaycheckEmployee({
            paycheck,
            paycheck_id: paycheck_exists.id,
          })
          this.$set(this.form.status, index, 'success')
        } catch (error) {
          this.$set(this.form.status, index, 'error')
        }
      }
    },
    clearData() {
      this.form.docs = []
      this.form.status = []
      this.form.employees = []
      this.form.date = []
      this.mensages.error = false
      this.mensages.refresh = false
    },
  },
}
</script>
